import axios from "axios";
import { RELOAD_CAMPAIGN } from "./actionTypes";
export const setCampaignState = (campaignState) => {
  console.log("action...", campaignState);
  return {
    type: RELOAD_CAMPAIGN,
    campaignState: campaignState,
  };
};
